const actionTypes = {
  SET_ALL_COACHES: 'SET_ALL_COACHES',
  SET_ALL_UNVERIFIED_COACHES: 'SET_ALL_UNVERIFIED_COACHES',
  UPSERT_COACH: 'UPSERT_COACH',
  DELETE_COACH: 'DELETE_COACH',
  STORE_INCOMING_COACH_PAGINATION: 'STORE_INCOMING_COACH_PAGINATION',
  STORE_ONBOARDED_COACH_PAGINATION: 'STORE_ONBOARDED_COACH_PAGINATION',
  KYC_COACH_PAGINATION: 'KYC_COACH_PAGINATION',
  INCOMING_FILTERS: 'INCOMING_FILTERS',
  ONBOARDED_FILTERS: 'ONBOARDED_FILTERS',
  KYC_FILTERS: 'KYC_FILTERS',
};

export function setAllCoaches(coaches) {
  return { type: actionTypes.SET_ALL_COACHES, coaches };
}

export function setCoachKycPagination(pagination) {
  return { type: actionTypes.KYC_COACH_PAGINATION, pagination };
}

export function setIncomingFilters(filters) {
  return { type: actionTypes.INCOMING_FILTERS, filters };
}

export function setOnboardedFilters(filters) {
  return { type: actionTypes.ONBOARDED_FILTERS, filters };
}

export function setKycFilters(filters) {
  return { type: actionTypes.KYC_FILTERS, filters };
}

export function setAllUnverifiedCoaches(unverifiedCoaches) {
  return { type: actionTypes.SET_ALL_UNVERIFIED_COACHES, unverifiedCoaches };
}

export function upsertCoach(coach) {
  return { type: actionTypes.UPSERT_COACH, coach };
}

export function deleteCoach(coachId) {
  return { type: actionTypes.DELETE_COACH, coachId };
}

export function storeIncomingCoachPagination(page) {
  return { type: actionTypes.STORE_INCOMING_COACH_PAGINATION, page };
}

export function storeOnboardedCoachPagination(page) {
  return { type: actionTypes.STORE_ONBOARDED_COACH_PAGINATION, page };
}

export default function coachReducer(
  state = {
    coaches: [],
    unverifiedCoaches: [],
    incomingCoachPagination: 1,
    onboardedCoachPagination: 1,
    kycPagination: 1,
    incomingFilters: {},
    onboardedFilters: {},
    kycFilters: {},
  },
  action
) {
  switch (action.type) {
    case actionTypes.SET_ALL_COACHES: {
      return { ...state, coaches: action.coaches };
    }
    case actionTypes.SET_ALL_UNVERIFIED_COACHES: {
      return { ...state, unverifiedCoaches: action.unverifiedCoaches };
    }
    case actionTypes.STORE_INCOMING_COACH_PAGINATION: {
      return { ...state, incomingCoachPagination: action.page };
    }
    case actionTypes.STORE_ONBOARDED_COACH_PAGINATION: {
      return { ...state, onboardedCoachPagination: action.page };
    }
    case actionTypes.KYC_COACH_PAGINATION: {
      return { ...state, kycPagination: action.pagination };
    }
    case actionTypes.INCOMING_FILTERS: {
      return { ...state, incomingFilters: action.filters };
    }
    case actionTypes.ONBOARDED_FILTERS: {
      return { ...state, onboardedFilters: action.filters };
    }
    case actionTypes.KYC_FILTERS: {
      return { ...state, kycFilters: action.filters };
    }
    case actionTypes.UPSERT_COACH: {
      const coachPosition = state.coaches.findIndex(
        (c) => c.userId === action.coach.userId
      );
      let clonedCoaches = [...state.coaches];
      if (coachPosition > -1) {
        clonedCoaches.splice(coachPosition, 1, action.coach);
      } else {
        clonedCoaches = [action.coach, ...clonedCoaches];
      }
      return {
        ...state,
        coaches: clonedCoaches,
      };
    }
    case actionTypes.DELETE_COACH: {
      return {
        ...state,
        coaches: [...state.coaches.filter((t) => t.userId !== action.coachId)],
      };
    }
    default:
      return state;
  }
}
export const kycPaginationSelector = (state) => {
  return state.coachReducer.kycPagination;
};
export const incomingCoachPaginationSelector = (state) => {
  return state.coachReducer.incomingCoachPagination;
};
export const onboardedCoachPaginationSelector = (state) => {
  return state.coachReducer.onboardedCoachPagination;
};
export const incomingFiltersSelector = (state) => {
  return state.coachReducer.incomingFilters;
};
export const onboardedFiltersSelector = (state) => {
  return state.coachReducer.onboardedFilters;
};
export const kycFiltersSelector = (state) => {
  return state.coachReducer.kycFilters;
};

export const coachesSelector = (state) => state.coachReducer.coaches;
export const unverifiedCoachesSelector = (state) =>
  state.coachReducer.unverifiedCoaches;
